enum WalletState {
    Active = "ACTIVE",
    Closed = "CLOSED"
}
export default WalletState